/**
 * Para onde vai quem clica em "Falar com vendas".
 *
 * A compra dos planos é atendida por uma pessoa (decisão do ADM, 01/09): não há
 * PSP configurado, e a fatura sai à mão. Então o cartão de plano não leva a um
 * checkout — leva a um canal de conversa, e ESTE módulo é o único lugar que
 * sabe qual é.
 *
 * Nasce vazio de propósito, pela mesma razão de `funil.ts`: um endereço
 * chumbado no código vira o endereço errado no dia em que a instância é de
 * outra empresa, e ninguém percebe porque nada quebra — o e-mail só passa a
 * cair na caixa de alguém que não vende. Sem configuração, o botão não some
 * (o plano continua existindo): ele deixa de prometer um canal que não existe.
 *
 * FLAG DE BUILD (Vite substitui por literal no bundle): trocar a variável no
 * contêiner não muda nada, é preciso rebuildar a imagem.
 *
 * Aceita e-mail (`vendas@empresa.com`), link (`https://wa.me/55...`) ou
 * `mailto:`/`tel:` já prontos — quem escreve a configuração não deveria
 * precisar saber qual prefixo o navegador quer.
 */
export function contatoDeVendas(): string | null {
  const bruto = (import.meta.env.VITE_CONTATO_VENDAS ?? '').trim();
  if (!bruto) return null;
  if (/^(https?|mailto|tel):/i.test(bruto)) return bruto;
  if (bruto.includes('@')) return `mailto:${bruto}`;
  // Só dígitos (com ou sem +, espaços, parênteses) = telefone → WhatsApp.
  const digitos = bruto.replace(/[\s()+-]/g, '');
  if (/^\d{8,15}$/.test(digitos)) return `https://wa.me/${digitos}`;
  return null;
}
